import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../common/models/httpError";
import {PageableModel} from "../../common/models/table";
import http from "../../common/services/httpService";
import {Api, apiUrls} from "../../helpers/api";
import {EntryOrExitModel} from "../models/entryOrExit";

export class EntryOrExitService {
    public static async getAll(): Promise<AxiosResponse<PageableModel<EntryOrExitModel>>> {
        return await http.get<PageableModel<EntryOrExitModel>>(`${Api.getUrl(apiUrls.place.entryOrExit)}`);
    }

    public static async allowOrNotAllowLocation(locationId: string, allow: boolean): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        const urlSuffix = allow ? "allow" : "disallow";

        return await http.post(`${Api.getUrl(apiUrls.place.entryOrExit)}/${locationId}/${urlSuffix}`);
    }

    public static async openOrCloseAllLocation(locationId: string, open: boolean): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        const urlSuffix = open ? "open-all" : "close-all";

        return await http.post(`${Api.getUrl(apiUrls.place.entryOrExit)}/${locationId}/${urlSuffix}`);
    }
}
